(() => {
  'use strict';
  const cache = new Map();
  const pending = new WeakSet();
  function active(node, now = Date.now()) {
    return Number(node.dataset.salePercent) > 0 && now >= Number(node.dataset.saleStart) * 1000 && now < Number(node.dataset.saleEnd) * 1000;
  }
  function refresh(root = document) {
    root.querySelectorAll('[data-sale-price]').forEach(node => {
      const on = active(node);
      node.querySelector('[data-sale-regular]')?.toggleAttribute('hidden', on);
      node.querySelector('[data-sale-offer]')?.toggleAttribute('hidden', !on);
      node.dataset.saleActive = String(on);
    });
  }
  async function priceFor(url) {
    const endpoint = new URL(url, location.origin);
    const variant = endpoint.searchParams.get('variant'); endpoint.search = ''; endpoint.hash = '';
    if (variant) endpoint.searchParams.set('variant', variant);
    endpoint.searchParams.set('section_id', 'product-sale-price');
    const preview = new URL(location.href).searchParams.get('preview_theme_id');
    if (preview) endpoint.searchParams.set('preview_theme_id', preview);
    const key = endpoint.toString();
    const cached = cache.get(key); if (cached && Date.now() - cached.time < 60000) return cached.value;
    const value = (async () => {
      const response = await fetch(endpoint, { signal: AbortSignal.timeout(10000) });
      if (!response.ok) throw new Error('Price unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const price = doc.querySelector('[data-sale-price]');
      if (!price || variant && price.dataset.variantId !== variant) throw new Error('Variant mismatch');
      return price;
    })();
    cache.set(key, { time: Date.now(), value }); value.catch(() => cache.delete(key)); return value;
  }
  async function dynamicCards(root = document) {
    const cards = [...root.querySelectorAll('[data-featured-products] .product-card')].filter(card => !card.querySelector('[data-sale-price]') && !pending.has(card));
    for (let start = 0; start < cards.length; start += 4) {
      await Promise.allSettled(cards.slice(start, start + 4).map(async card => {
        const link = card.querySelector('.product-card-link'); const price = card.querySelector('.product-bottom strong');
        if (!link || !price) return; pending.add(card);
        try { const node = (await priceFor(link.href)).cloneNode(true); if (card.isConnected && price.isConnected) price.replaceWith(node); } catch {}
      }));
    }
    refresh();
  }
  function productVariants(root = document) {
    root.querySelectorAll('.catalog-product-section').forEach(section => {
      const select = section.querySelector('[data-product-variant-select]');
      const container = section.querySelector('.product-price');
      if (!select || !container || select.dataset.saleReady) return;
      select.dataset.saleReady = 'true'; let revision = 0;
      select.addEventListener('change', async () => {
        const current = ++revision, option = select.selectedOptions[0];
        container.textContent = option?.dataset.regularMoney || '';
        const url = new URL(location.href); url.searchParams.set('variant', select.value);
        try { const node = (await priceFor(url)).cloneNode(true); if (current === revision) { container.replaceChildren(node); refresh(); } } catch {}
      });
    });
  }
  const start = () => { refresh(); productVariants(); dynamicCards(); };
  document.addEventListener('DOMContentLoaded', start);
  document.addEventListener('shopify:section:load', start);
  let timer;
  new MutationObserver(records => { if (!records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('.product-card, [data-sale-price]') || n.querySelector?.('.product-card, [data-sale-price]'))))) return; clearTimeout(timer); timer = setTimeout(start, 50); }).observe(document.documentElement, { childList: true, subtree: true });
  setInterval(refresh, 1000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
  window.TruckSaleDisplay = Object.freeze({ active });
})();
